<template>
  <v-col class="left-side" cols="1" md="1">
    <template v-if="npaFromZones">
      <v-btn class="btn-add" @click="editNpa">
        <img src="@/assets/img/add-green.png" alt="icon">
      </v-btn>
    </template>
    <template v-else>
      <v-btn class="btn-add-category" @click="editNpa">
        <img v-if="!npaEdit" src="@/assets/img/plus-icon.png" alt="icon">
        <slot></slot>
      </v-btn>
    </template>
    <v-dialog v-model="npaDialog" max-width="940">
      <v-card class="modal npa-modal">
        <div class="modal-head">
          <template v-if="!npaEdit">
            {{ $t('Добавление') }}
          </template>
          <template v-else>
            {{ $t('Редактирование') }}
          </template>
          <v-btn color="modal-close" @click.native="resetNpaAdd(false)">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <div class="tab-main">
            <v-form
              class="form-ru"
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="createNpa"
            >
              <v-tabs
                background-color="white"
                left
                v-model="langNpaTab"
              >
                <v-tab>Русский</v-tab>
                <v-tab>Кыргызча</v-tab>
                <v-tab>English</v-tab>
                <v-tab-item v-for="tabItem in tabItems" :key="tabItem.description">
                  <div :class="{ 'form-label-copy': !tabItem.main }">
                    <v-row :class="{ invalid: $v.npa.name.$error && tabItem.main }">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Наименование') }}: <span v-if="tabItem.main" class="asterix">*</span>
                          <fieldInfo :info="$t('Наименование')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <Copy v-if="!tabItem.main" :original="npa[tabItem.nameMain]"
                              @copyText="copyText($event, tabItem.name)"/>
                        <v-text-field
                          v-model="npa[tabItem.name]"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Текст') }}:
                          <fieldInfo :info="$t('Текст')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <Copy v-if="!tabItem.main" :original="npa[tabItem.textMain]"
                              @copyText="copyText($event, tabItem.text)"/>
                        <ckeditor
                          :editor="editor"
                          v-model="npa[tabItem.text]"
                          :config="editorConfig"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main" :class="{invalid: $v.npa.adoptionDate.$error}">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Дата принятия') }}: <span class="asterix">*</span>
                          <fieldInfo :info="$t('Дата принятия')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <div class="form-date">
                          <v-menu
                            v-model="dateMenuNpa"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="computedDateFormatted"
                                v-on="on"
                                outlined
                                rounded
                                dense
                                prepend-icon="event"
                              />
                            </template>
                            <v-date-picker
                              v-model="npa.adoptionDate"
                              @input="dateMenuNpa = false"
                              no-title
                              first-day-of-week="1"
                            />
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main" :class="{invalid: $v.npa.npaNumber.$error}">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Номер') }}: <span class="asterix">*</span>
                          <fieldInfo :info="$t('Номер')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model.number="npa.npaNumber"
                          required
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main" :class="{invalid: $v.npa.link.$error}">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Ссылка') }}:
                          <fieldInfo :info="$t('Ссылка')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-text-field
                          v-model="npa.link"
                          outlined
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="tabItem.main">
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Привязан к ООПТ') }}:
                          <fieldInfo :info="$t('Привязан к ООПТ')"/>
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-checkbox
                          v-model="npa.snapOOPT"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                </v-tab-item>
              </v-tabs>
              <div class="form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Сохранить') }}
                </button>
                <button
                  class="btn btn-default gray"
                  type="button"
                  @click="resetNpaAdd(false)"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </v-form>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import NPA from '@/model/npa'
import { url, required } from 'vuelidate/lib/validators'
import fieldInfo from '@/components/app/fieldInfo'
import Copy from '@/components/oopt/Copy'
import moment from 'moment'

// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
  components: {
    Copy,
    fieldInfo
  },
  props: {
    ooptId: Number,
    npaId: Number,
    npaFromZones: {
      type: Boolean,
      default: false
    },
    npaEdit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    data: [],
    npaDialog: false,
    dateMenuNpa: false,
    langNpaTab: null,
    npa: {
      id: '',
      name: '',
      nameKg: '',
      nameEn: '',
      text: '',
      textKg: '',
      textEn: '',
      npaNumber: '',
      adoptionDate: '',
      link: '',
      snapOOPT: false
    },
    rules: {
      npa: {
        name: { required },
        npaNumber: { required },
        adoptionDate: { required },
        link: { url }
      }
    },
    tabItems: [
      {
        main: true,
        name: 'name',
        text: 'text'
      },
      {
        main: false,
        nameMain: 'name',
        name: 'nameKg',
        textMain: 'text',
        text: 'textKg'
      },
      {
        main: false,
        nameMain: 'name',
        name: 'nameEn',
        textMain: 'text',
        text: 'textEn'
      }
    ],
    valid: true,
    // editor
    editor: ClassicEditor,
    editorData: '',
    editorConfig: {
      plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        LinkPlugin,
        ParagraphPlugin,
        HeadingPlugin,
        HorizontalLine,
        Alignment,
        Table,
        TableToolbar
      ],
      toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'alignment',
        '|',
        'horizontalLine',
        '|',
        'undo',
        'redo',
        '|',
        'insertTable'
      ],
      table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
      },
      heading: {
        options: [
          {
            model: 'paragraph',
            title: 'Paragraph',
            class: 'ck-heading_paragraph'
          },
          {
            model: 'heading1',
            view: 'h1',
            title: 'Heading 1',
            class: 'ck-heading_heading1'
          },
          {
            model: 'heading2',
            view: 'h2',
            title: 'Heading 2',
            class: 'ck-heading_heading2'
          },
          {
            model: 'heading3',
            view: 'h3',
            title: 'Heading 3',
            class: 'ck-heading_heading3'
          }
        ]
      }
    }
  }),
  validations () {
    return this.rules
  },
  computed: {
    computedDateFormatted () {
      return this.npa.adoptionDate ? moment(this.npa.adoptionDate).format('DD.MM.YYYY') : ''
    }
  },
  methods: {
    // Обновление формы для добавления
    resetNpaAdd (flag) {
      this.npaDialog = flag
      this.npa = {
        id: '',
        name: '',
        nameKg: '',
        nameEn: '',
        text: '',
        textKg: '',
        textEn: '',
        npaNumber: '',
        adoptionDate: '',
        link: '',
        snapOOPT: false
      }
      this.$v.$reset()
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание НПА
    createNpa () {
      if (!this.validateForm()) {
        return
      }

      NPA.create(this.ooptId, this.npa)
        .then((response) => {
          if (response.status === 201) {
            this.$noty.success(this.npaEdit ? this.$i18n.t('Успешно обновлено') : this.$i18n.t('Успешно добавлено'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.updateNpaList(response.data.refNpa)
            this.resetNpaAdd(false)
          }
        })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    editNpa () {
      if (this.npaEdit && this.npaId) {
        NPA.getEdit(this.npaId)
          .then((response) => {
            this.npa = response.data
            this.npaDialog = true
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.resetNpaAdd(true)
      }
    },
    // Обновление списка НПА
    updateNpaList (lists) {
      this.$emit('updateNpaList', lists)
    },
    // Копирование текста для мультиязычности
    copyText (title, refName) {
      this.npa[refName] = title
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>
